import { useState, useEffect } from 'react'
import { getConteudoChave, CONTEUDO_CHAVES } from '@/api/adminApi'
import { ClientPageLayout, clientPageStyles as layout } from '@/components/ClientPageLayout'
import { parseContatos, buildContactRows } from '@/utils/contatos'
import { useRequireConteudoFlag } from '@/utils/featureFlags'

export function ContatosPage() {
  const { loading: featureLoading } = useRequireConteudoFlag(CONTEUDO_CHAVES.menu_show_contatos)
  const [data, setData] = useState(() => parseContatos(null))
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    getConteudoChave(CONTEUDO_CHAVES.contatos)
      .then((v) => {
        if (!cancelled) setData(parseContatos(v ?? null))
      })
      .catch(() => {
        if (!cancelled) setData(parseContatos(null))
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [])

  const rows = buildContactRows(data)

  if (featureLoading) return null

  return (
    <ClientPageLayout
      loading={loading}
      empty={rows.length === 0}
      emptyMessage="Os contactos serão publicados em breve."
      emptyIcon="📇"
    >
      <p className={layout.lead}>Fale connosco — estamos à sua disposição.</p>
      <div className={layout.contactGrid}>
        {rows.map((row) => {
          const inner = (
            <>
              <span className={layout.contactIcon} aria-hidden>
                {row.icon}
              </span>
              <span className={layout.contactBody}>
                <span className={layout.contactLabel}>{row.label}</span>
                <span className={layout.contactValue}>{row.value}</span>
                {row.hint && <span className={layout.contactHint}>{row.hint}</span>}
              </span>
            </>
          )
          if (row.href) {
            return (
              <a
                key={row.key}
                href={row.href}
                className={layout.contactCard}
                target="_blank"
                rel="noopener noreferrer"
              >
                {inner}
              </a>
            )
          }
          return (
            <div key={row.key} className={layout.contactCard}>
              {inner}
            </div>
          )
        })}
      </div>
    </ClientPageLayout>
  )
}
